/**
 * ✅ Fotoğrafı yüklemeden önce tarayıcıda küçültür.
 * Telefon fotoğrafları 5–15 MB olabiliyor; sunucu en fazla 11 MB kabul ediyor ve büyük
 * dosyalar yavaş yükleniyor. Uzun kenar en fazla 2000 px, JPEG kalite 0.85 → genelde 300–800 KB.
 *
 * Tarayıcının çözemediği türler (ör. Chrome'da HEIC) ve PDF'ler olduğu gibi döner.
 */
const COMPRESSIBLE = ['image/jpeg', 'image/png', 'image/webp'];

export const compressImage = async (file, { maxSide = 2000, quality = 0.85, minBytes = 1.5 * 1024 * 1024 } = {}) => {
  if (!file || !COMPRESSIBLE.includes(file.type) || file.size < minBytes) return file;
  try {
    const url = URL.createObjectURL(file);
    const img = await new Promise((resolve, reject) => {
      const el = new Image();
      el.onload = () => resolve(el);
      el.onerror = reject;
      el.src = url;
    });
    URL.revokeObjectURL(url);

    const scale = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
    const w = Math.round(img.naturalWidth * scale);
    const h = Math.round(img.naturalHeight * scale);
    const canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff'; // şeffaf PNG'ler JPEG'de siyah olmasın
    ctx.fillRect(0, 0, w, h);
    ctx.drawImage(img, 0, 0, w, h);

    const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
    if (!blob || blob.size >= file.size) return file;
    const name = file.name.replace(/\.[^.]+$/, '') + '.jpg';
    return new File([blob], name, { type: 'image/jpeg', lastModified: Date.now() });
  } catch (_) {
    return file; // küçültülemezse orijinali yükle
  }
};

export default compressImage;
